import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { Table, TableHead, TableCell, TableRow, TableBody, Radio, Checkbox, Icon, Typography, Grid, TextField } from '@material-ui/core';
import { ExpansionPanel, ExpansionPanelSummary, ExpansionPanelDetails } from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import QuestionGradeIcon from '../components/QuestionGradeIcon';
import * as Actions from '../store/actions';
import NoteList from '../../../components/note/NoteList';
import NoteInfo from '../../../components/note/NoteInfo';
import * as CanvasFunctions from '../components/CanvasFunctions';

const styles = theme => ({
    root: {
        width: '100%',
    },
    heading: {
        fontSize: theme.typography.pxToRem(15),
    },
    secondaryHeading: {
        fontSize: theme.typography.pxToRem(15),
        color: theme.palette.text.secondary,
    },
    icon: {
        verticalAlign: 'bottom',
        height: 20,
        width: 20,
    },
    details: {
        alignItems: 'center',
    },
    column: {
        flexBasis: '20%',
    },
    expansion: {
        background: '#FAFAFA',
    }
});

class GraderQuestion extends Component {
    svgRef = React.createRef();
    state = {
        svgCoord: {},
        obj_list: []
    }

    componentDidMount = () => {
        const { question } = this.props;
        let svgCoord = {};

        if (this.svgRef.current !== null) {
            svgCoord = this.svgRef.current.getBoundingClientRect();
        }

        this.setState({
            obj_list: CanvasFunctions.parseRelativeCoordinatesForObjList(question.image.shape_list, svgCoord),
            svgCoord: svgCoord
        });
    }

    handleChange = (field_name) => (event) => {
        const { question, updateStudentQuestion } = this.props;
        let new_value = event.target.value;

        const update_data = {
            [field_name]: new_value
        }

        updateStudentQuestion(
            question.header.question_id, 
            question.header.student_quiz_id, 
            question.header.question_type_id, 
            update_data
        );
    }

    handleBlur = (field_name) => (event) => {
        const { question, updateStudentQuestion } = this.props;
        let new_value = event.target.value;

        if (field_name === 'Score') {
            new_value = Math.abs(Number(new_value)).toFixed(1);

            if (isNaN(new_value)) {
                new_value = Number(0.00).toFixed(1);
            }
        }

        const update_data = {
            [field_name]: new_value
        }
        
        updateStudentQuestion(
            question.header.question_id,
            question.header.student_quiz_id,
            question.header.question_type_id,
            update_data
        );
    }

    isAnswerSelected = (answer_id, studentAnswerList) => {
        let is_selected = false;

        if(typeof studentAnswerList !== 'undefined') {
            studentAnswerList.forEach((student_answer) => {
                if(student_answer.answer_id === answer_id) {
                    is_selected = true;
                }
            });
        }

        return is_selected;
    }

    getStudentAnswerOrder = (answer_id, studentAnswerList) => {
        let student_order = 0;

        if (typeof studentAnswerList !== 'undefined') {
            studentAnswerList.forEach((student_answer) => {
                if (student_answer.answer_id === answer_id) {
                    student_order = student_answer.AnswerOrder;
                }
            });
        }

        return student_order;
    }

    getAnswerContent = (question, studentQuestion) => {
        switch (question.header.question_type_id)
        {
            case(4): // Multiple Answer
            case(1): // Multiple Choice
            {
                return (
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell style={{ width: '10%' }}>Answers</TableCell>
                                <TableCell style={{ width: '10%' }}></TableCell>
                                <TableCell></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {question.answerList.map((answer) =>
                                <TableRow key={answer.header.answer_id}>
                                    <TableCell>
                                        {(answer.header.Correct ? <Icon style={{ color: 'green' }}>check</Icon> : <Icon style={{ color: 'red' }}>close</Icon>)}
                                    </TableCell>
                                    <TableCell>
                                        {question.header.question_type_id === 1 ?
                                            <Radio
                                                checked={this.isAnswerSelected(answer.header.answer_id, studentQuestion.studentAnswerList)}
                                                disabled
                                            />
                                            :
                                            <Checkbox
                                                checked={this.isAnswerSelected(answer.header.answer_id, studentQuestion.studentAnswerList)}
                                                disabled
                                            />
                                        }
                                    </TableCell>
                                    <TableCell>
                                        {answer.header.AnswerText}
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                );
            }
            case(2): // Short Answer
            case(3): // Long Answer
            {
                let studentAnswerText    = typeof studentQuestion.studentAnswerList[0] !== 'undefined' ? studentQuestion.studentAnswerList[0].AnswerText || '' : '';
                let instructorAnswerText = typeof question.answerList[0].header        !== 'undefined' ? question.answerList[0].header.AnswerText        || '' : '';

                return (
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell style={{ width: '10%' }}>Answers</TableCell>
                                <TableCell></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            <TableRow>
                                <TableCell>Student:</TableCell>
                                <TableCell>{studentAnswerText}</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>Instructor:</TableCell>
                                <TableCell>{instructorAnswerText}</TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                );
            }
            case(5): // Order Answer
            {
                return (
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell style={{ width: '10%' }}>Order</TableCell>
                                <TableCell style={{ width: '10%' }}>Answer</TableCell>
                                <TableCell>Text</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {question.correctList.map((answer) =>
                                <TableRow key={answer.header.answer_id}>
                                    <TableCell>
                                        {answer.header.CorrectOrder}
                                    </TableCell>
                                    <TableCell>
                                        {this.getStudentAnswerOrder(answer.header.answer_id, studentQuestion.studentAnswerList)}
                                    </TableCell>
                                    <TableCell>
                                        {answer.header.AnswerText}
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                );
            }
            case(6): // HotSpot
            {
                let student_answer_position = {};
                if (studentQuestion.studentAnswerList.length > 0) {
                    student_answer_position = CanvasFunctions.parseRelativeCoordinatesForObj({
                        id: studentQuestion.studentAnswerList[0].student_answer_id,
                        xPosition: studentQuestion.studentAnswerList[0].xPosition,
                        yPosition: studentQuestion.studentAnswerList[0].yPosition,
                        type: 'cross',
                    }, this.state.svgCoord);
                }

                return (
                    <div className="canvas_wrapper">
                        <div className="canvas" style={{ width: "640px", height: "360px" }}>
                            <svg ref={this.svgRef} >
                                <image href={question.image.URL} style={{ height: '100%', width: '100%' }} />
                                {CanvasFunctions.renderCanvas(this.state.obj_list.concat(student_answer_position))}
                            </svg>
                        </div>
                    </div>
                )
            }

            default: {
                return (<React.Fragment>Loading...</React.Fragment>);
            }
        }
    }
    render() {
        const { question, studentQuestion, classes } = this.props;
        const { viewQuestion } = this.props;

        if (typeof question === 'undefined' || typeof studentQuestion === 'undefined') {
            return <div>Loading...</div>;
        }

        const answer_content = this.getAnswerContent(question, studentQuestion);

        return (
            <React.Fragment>
                <ExpansionPanel expanded={question.isOpen || false}>
                    <ExpansionPanelSummary
                        className={classes.expansion}
                        onClick={() => viewQuestion(question.header.question_id)}
                        expandIcon={
                            <ExpandMoreIcon />
                        }
                    >
                        <div className={classes.column}>
                            <Typography className={classes.heading}>Question #{question.header.DisplayOrder}</Typography>
                        </div>
                        <div className={classes.column}>
                            <TextField
                                label="Score"
                                className={classes.textField}
                                value={studentQuestion.Score}
                                margin="normal"
                                variant="outlined"
                                onClick={(event) => {event.preventDefault(); event.stopPropagation();}}
                                onChange={this.handleChange('Score')}
                                onBlur={this.handleBlur('Score')}
                                type='number'
                                inputProps={{
                                    min: 0.00,
                                    step: 1
                                }}
                            />
                        </div>
                        <div className={classes.column}>
                            <QuestionGradeIcon
                                question={question}
                                studentQuestion={studentQuestion}
                            />
                        </div>
                        <div className={classes.column}>
                            <Typography className={classes.heading}>
                                {studentQuestion.Score}/{question.header.Score}
                            </Typography>
                        </div>
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails className={classes.details}>
                        <Grid container spacing={16}>
                            <Grid item xs={12}>
                                <Typography variant="h6">{question.header.QuestionText}</Typography>
                            </Grid>
                            <Grid item xs={6}>
                                {answer_content}
                            </Grid>
                            <Grid item xs={6}>
                                <NoteInfo
                                    type="instructor"
                                    table_name='student_question'
                                    table_id={studentQuestion.student_question_id}
                                />
                            </Grid>
                        </Grid>
                    </ExpansionPanelDetails>
                </ExpansionPanel>
            </React.Fragment>
        )
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        setQuestion:              Actions.setQuestion,
        viewQuestion:             Actions.viewQuestion,
        updateStudentQuestion:    Actions.updateStudentQuestion
    }, dispatch);
}

function mapStateToProps({ quizApp }) {
    return {
        quiz:                   quizApp.quizzes.currentQuiz,
        studentAnswers:         quizApp.quizViewer.studentAnswers,
    }
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(GraderQuestion)));



// WEBPACK FOOTER //
// src/main/content/quiz/quizGrader/GraderQuestion.js